import React, {forwardRef, ReactNode, SyntheticEvent, useEffect, useImperativeHandle, useRef} from "react";
import styles from "./modal.module.scss";
import ModalOverlay from "../modal-overlay/modal-overlay";
import { createPortal } from "react-dom";

const modalRoot = document.getElementById("react-modals")!;

interface classes {
  modalOverlay?: string;
}

interface ModalProps {
  onClose?: () => void;
  children: ReactNode;
  showCloseBtn?: boolean;
  closeClass?: string;
  className?: string
  classes?: classes;
  closeOnOverlayClick?: boolean
}

const Modal = forwardRef<HTMLDivElement, ModalProps>(({
                                                        children,
                                                        onClose,
                                                        showCloseBtn = true,
                                                        closeClass,
                                                        className,
                                                        classes = {},
                                                        closeOnOverlayClick = true,
                                                      }, ref) => {
  const modalRef = useRef<HTMLDivElement>(null);
  useImperativeHandle(ref, () => modalRef.current!, []);
  function handleCloseModal() {
    if (!!onClose) {
      onClose();
    }
  }
  function handleOnClick(e: SyntheticEvent) {
    e.stopPropagation();
  }
  
  useEffect(() => {
    const handleEscapePress = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleCloseModal();
      }
    };
    window.addEventListener("keydown", handleEscapePress);

    return () => {
      window.removeEventListener("keydown", handleEscapePress);
    };
  }, []);
  return createPortal(
    <ModalOverlay modalOverlay={classes.modalOverlay} closeModal={closeOnOverlayClick ? handleCloseModal : undefined}>
      <div ref={modalRef} className={`${styles.modal} ${className}`} onClick={handleOnClick}>
        {onClose != null && showCloseBtn && (
          <span className={`${styles.close} ${closeClass}`} onClick={handleCloseModal}>
          </span>
        )}
        {children}
      </div>
    </ModalOverlay>,
    modalRoot,
  );
})

export default Modal;
